var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPublicFilled = function SvgPublicFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "m15 17.67 1-2-2.948-1.98-1.943-.125L10 14.67l2 3h3ZM12.813 3.035A8.993 8.993 0 0 0 3.702 8.5L8 11.67l1.005-1.995L13 8.67l1.5-5.318a8.715 8.715 0 0 0-1.687-.317Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.813 3.035a8.994 8.994 0 0 0-9.778 9.778c.372 4.279 3.872 7.779 8.151 8.151a8.993 8.993 0 0 0 9.778-9.778c-.372-4.278-3.872-7.778-8.151-8.151Zm0 0A8.993 8.993 0 0 0 3.702 8.5L8 11.67l1.005-1.995L13 8.67l1.5-5.318a8.715 8.715 0 0 0-1.687-.317ZM15 17.67l1-2-2.948-1.98-1.943-.125L10 14.67l2 3h3Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPublicFilled);
export default ForwardRef;